(() => {
  function initialize(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const config = JSON.parse(root.querySelector('[data-teen-config]').textContent);
    const cleanse = root.querySelector('[data-cleanse-body]');
    const initialCleanse = cleanse.textContent;
    const morningOption = root.querySelector('input[value="am"]');
    const makeup = root.querySelector('[data-makeup]');
    const sports = root.querySelector('[data-sports]');
    const title = root.querySelector('[data-plan-title]');
    const remove = root.querySelector('[data-remove]');
    const sunscreen = root.querySelector('[data-spf]');
    const sportsNote = root.querySelector('[data-sports-note]');
    const makeupNote = root.querySelector('[data-makeup-note]');
    root.querySelector('[data-remove-title]').textContent = config.remove_title;
    root.querySelector('[data-remove-body]').textContent = config.remove_body;
    function updateRoutine() {
      const morning = morningOption.checked;
      title.textContent = morning ? config.morning_heading : config.evening_heading;
      cleanse.textContent = morning ? initialCleanse : config.night_cleanse;
      remove.hidden = morning || !makeup.checked;
      sunscreen.hidden = !morning;
      sportsNote.hidden = !sports.checked;
      sportsNote.textContent = morning ? config.sports_am : config.sports_pm;
      makeupNote.hidden = !morning || !makeup.checked;
      makeupNote.textContent = config.makeup_am;
    }
    root.querySelectorAll('.dt-routine-controls input').forEach(input => input.addEventListener('change', updateRoutine));
    const search = root.querySelector('[data-search]');
    const buttons = Array.from(root.querySelectorAll('[data-topic-button]'));
    const questions = Array.from(root.querySelectorAll('[data-question]'));
    const count = root.querySelector('[data-result-count]');
    const empty = root.querySelector('[data-empty]');
    let topic = 'all';
    function updateQuestions() {
      const query = search.value.toLocaleLowerCase().trim();
      let visible = 0;
      questions.forEach(question => {
        const show = (topic === 'all' || question.dataset.topic === topic) && (!query || question.textContent.toLocaleLowerCase().includes(query));
        question.hidden = !show;
        if (!show) question.open = false;
        if (show) visible += 1;
      });
      count.textContent = `${visible} / ${questions.length} ${config.count}`;
      empty.hidden = visible !== 0;
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.topicButton === topic)));
    }
    buttons.forEach(button => button.addEventListener('click', () => {
      topic = button.dataset.topicButton;
      updateQuestions();
    }));
    search.addEventListener('input', updateQuestions);
    root.querySelector('[data-reset]').addEventListener('click', () => {
      search.value = '';
      topic = 'all';
      updateQuestions();
      search.focus();
    });
    root.querySelector('[data-question-tools]').hidden = false;
    updateRoutine();
    updateQuestions();
  }
  document.querySelectorAll('[data-teen-learning]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => {
    const root = event.target.querySelector('[data-teen-learning]');
    if (root) initialize(root);
  });
})();
